import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import {PersistGate} from 'redux-persist/lib/integration/react';
import AdminLayout from './layouts/index';
import store, {persistor} from './stores/configureStore';
import {I18nextProvider} from 'react-i18next';
import i18n from './translations/i18n';
import './assets/css/site.css';
import {ROUTE} from './common/constant';

const token = localStorage.getItem('TOKEN_KEY');

ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={<div />} persistor={persistor}>
        <BrowserRouter>
          <I18nextProvider i18n={i18n}>
            <Switch>
              <Route path="/payment" render={(props) => <AdminLayout {...props} />} />
              <Redirect from="/" to={token ? ROUTE.LAYOUT + ROUTE.PAYMENT_PRODUCT : '/payment/login'} />
            </Switch>
          </I18nextProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>,
    document.getElementById('root'),
);
